import { bindActionCreators } from 'redux'

import { getProfiles, clearFilterSort } from 'reduxpath/ducks/Profile/List'
import {
  getProfileById,
  getFinanceProfileByProfileId,
  getProfileBankByProfileId,
  getProductByProfileId,
  getProjectByProfileId,
  getProfileTaxUrl,
  getFinanceProfileTaxUrl,
  clearProps,
} from 'reduxpath/ducks/Profile/Detail'

import {
  getCountries,
  setSelectionsCountry,
  setSelectedCountry,
  getSubsciptionPlan,
} from 'reduxpath/ducks/Reference'

import Home from 'units/Profile'
import List from 'units/Profile/units/List'
import ProfileDetail from 'components/ProfileDetail'

const list = store => {
  const { selectedCountry } = store.getState().Reference

  if (selectedCountry) {
    store.dispatch(setSelectedCountry(selectedCountry))
  }

  store.dispatch(
    getProfiles({
      sort: 'name ASC',
      limit: 10,
      skip: 0,
    })
  )

  store.dispatch(clearFilterSort())
  store.dispatch(getSubsciptionPlan())

  store.dispatch(
    getCountries(countries => {
      store.dispatch(setSelectionsCountry(countries.rows))
    })
  )
}

const detail = (store, profileId) => {
  const actions = bindActionCreators(
    {
      getProfileById,
      getFinanceProfileByProfileId,
      getProfileBankByProfileId,
      getProductByProfileId,
      getProjectByProfileId,
      getProfileTaxUrl,
      getFinanceProfileTaxUrl,
      clearProps,
    },
    store.dispatch
  )
  actions.getProfileById(profileId, profile => {
    actions.getProfileTaxUrl(profile.id)
    actions.getFinanceProfileByProfileId(profile.id, financeProfile => {
      actions.getFinanceProfileTaxUrl(financeProfile.rows[0].id)
    })
    actions.getProfileBankByProfileId(profile.id)
    actions.getProductByProfileId(profileId, {
      limit: 25,
    })
    actions.getProjectByProfileId(profileId, {
      limit: 25,
    })
    actions.clearProps()
  })
}

export default {
  populate: {
    list,
    detail,
  },
  components: {
    Home,
    List,
    ProfileDetail,
  },
}
